import { render, staticRenderFns } from "./UbahPassword.vue?vue&type=template&id=23a6b0e0&scoped=true"
import script from "./UbahPassword.vue?vue&type=script&lang=js"
export * from "./UbahPassword.vue?vue&type=script&lang=js"
import style0 from "./UbahPassword.vue?vue&type=style&index=0&id=23a6b0e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6b0e0",
  null
  
)

export default component.exports